export function modal() {
  const body = document.querySelector("body");
  const modalOpens = document.querySelectorAll(".js-modalOpen");
  const modal = document.querySelector(".js-modal");
  const modalHead = document.querySelector(".js-modal .c-modal_head");

  modalOpens.forEach(modalOpen => {
    modalOpen.addEventListener("click", () => {
      const target = document.querySelector(modalOpen.dataset.target);
      modal.querySelector(".c-modal_cont").innerHTML = target.innerHTML;
      modal.classList.add("is-active");
      body.classList.add("is-active");

      modalHead.classList.add("is-"+target.dataset.color);

      const swiper = new Swiper(`.c-modal_cont .swiper`, {
        spaceBetween: 40,
        pagination: {
          el: '.swiper-pagination',
        },
      });

      const closeBtn = document.querySelector(".js-close");
      closeBtn.addEventListener("click", ()=> {
        modal.classList.remove("is-active");
        body.classList.remove("is-active");
        modalHead.classList.remove("is-"+target.dataset.color);
        swiper.destroy()
      })
    })
  })

}
